module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xetR4F/Images/cover.jpg?1685327175113",
      "alt": "This image is the cover for the book Food for Thought, Tales of the Curious Cookbook"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Food for Thought, Tales of the Curious Cookbook\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("A Tale of the Curious Cookbook")])])]), _c('p', [_vm._v("Emmett Gant was planning to tell his father something really important one Sunday morning—but his father passed away first. Now, nearly three years later, Emmett can't seem to clear up who he should be with—the girl with the apple cheeks and the awesome family, or his snarky neighbor, Keegan, who never sees his family but who makes Emmett really happy just by coming over to chat.")]), _vm._v(" "), _c('p', [_vm._v("Emmett needs clarity.")]), _vm._v(" "), _c('p', [_vm._v("Fortunately for Emmett, his best friend’s mom has a cookbook that promises to give Emmett insight and good food, and Emmett is intrigued. After the cookbook follows him home, Emmett and Keegan decide to make the recipe “For Clarity,” and what ensues is both very clear—and a little surprising, especially to Emmett's girlfriend. Emmett is going to have to think hard about his past and the really important thing he forgot to tell his father if he wants to get the recipe for love just right.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Amy Lane\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0